import {FC, useState} from 'react';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
    useTheme
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {Home} from "@mui/icons-material";

const drawerWidth = 110;


const MyDrawer: FC<{}> = ({}) => {
    const theme = useTheme()
    const navigate = useNavigate()
    const [selectedItem, setSelectedItem] = useState(0)

    const menu = [
        {navigation: "/dashboard", label: "Dashboard", icon: <Home/>},
        {navigation: "/favoris", label: "Mes favoris", icon: <Home/>},
        {navigation: "/seen-movie", label: "Mes films visionnés", icon: <Home/>},
        {navigation: "/settings", label: "Paramètres", icon: <Home/>}]
    return (
        <Drawer
            variant="permanent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: {
                    backgroundColor: theme.palette.primary.main,
                    width: drawerWidth,
                    boxSizing: 'border-box'
                },
            }}
        >
            <Toolbar/>
            <Box sx={{overflow: 'auto'}}>
                <List>
                    {menu.map((item, index) => (
                        <ListItem key={index} disablePadding sx={{"& .Mui-selected": {backgroundColor: "#5D0101 !important"}}}>
                            <ListItemButton sx={{flexDirection: "column"}} selected={selectedItem === index + 1}
                                            onClick={() => {
                                                navigate(item.navigation)
                                                setSelectedItem(index + 1)
                                            }}>
                                <ListItemIcon sx={{justifyContent: "center"}}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.label} sx={{textAlign: "center"}}/>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Drawer>
    );
};

export default MyDrawer;
